import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";
import { toColor, toRgbaFunctionString } from "../../utils/color";
import { BadgeType } from "./entities";

const listingLine: IStyle = {
  width: 'auto',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: 400, 
};

export const getBwjListingLineHeight = (lineCount: number, badgeType: BadgeType) => {
  const lc = lineCount > 0 && lineCount < 5 ? lineCount - 1 :
  lineCount < 1 ? 0 : 3;
  const baseListingHeight = 60;

  const height = baseListingHeight + (lc * 20);
  return badgeType === BadgeType.Image && height < 100 ? 100 : height;
}

export const actionButtonClass = 'bwj-action-button';

export const useBwjListingStyles = () => {
  const theme = getTheme();
  const listingBorderRadius = 2;

  const boxShadow = '0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)';
  const listing: IStyle = {
    position: 'relative',
    backgroundColor: theme.palette.white,
    backgroundClip: 'padding-box',
    padding: '0 28px',
    marginBottom: 14,
    borderRadius: listingBorderRadius,
    '-webkit-box-shadow': boxShadow,
    boxShadow,
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
  };

  const selectedListing: IStyle = {
    ...listing,
    backgroundColor: theme.palette.themeLighterAlt,
  };

  const contentContainer: IStyle = {
    padding: 0,
    paddingTop: 12,
    margin: 0,
    marginRight: 36,
    flexGrow: 1,
    width: 'calc(100% - 60px)',
  };

  const imageContentContainer: IStyle = {
    ...contentContainer,
    width: 'calc(100% - 75px)',
  };

  const badgeSize = 45;
  const badge: IStyle = {
    color: theme.palette.white,
    width: badgeSize,
    height: badgeSize,
    lineHeight: badgeSize,
    textAlign: 'center',
    margin: 0,
    padding: 0,
    alignSelf: 'center',
  };

  const circularBadge: IStyle = {
    ...badge,
    borderRadius: '50%',
  };

  const semiSquareBadge: IStyle = {
    ...badge,
    borderTopLeftRadius: '25%',
    borderBottomRightRadius: '25%',
  };

  const iconBadge: IStyle = {
    ...badge,
    backgroundColor: 'transparent !important',
    fontSize: 39,
    color: theme.palette.themePrimary,
  };

  const imageBadge: IStyle = {
    ...badge,
    backgroundColor: 'transparent !important',
    width: 60,
    minWidth: 60,
    height: 75,
  };

  const title: IStyle = {
    ...listingLine,
    margin: 0,
    fontSize: 18,
    lineHeight: 24,
    color: theme.palette.neutralDark,
  };

  const invalidTitle: IStyle = {
    ...title,
    color: theme.semanticColors.errorText,
  };

  const contentText: IStyle = {
    ...listingLine,
    margin: 0,
    marginTop: 3,
    fontSize: 14,
    lineHeight: 21,
    color: theme.palette.neutralDark,
  };

  const footnote: IStyle = {
    ...contentText,
    color: theme.palette.neutralSecondary,
    fontSize: 12,
  };

  const actionButton: IStyle = {
    position: 'absolute',
    top: 12,
    right: 28,
    backgroundColor: 'transparent',
    display: 'none',
    fontSize: 24,
    border: 'none',

    '&:hover': {
      color: theme.palette.themeTertiary,
    },
  };

  const coverHoverColor = toRgbaFunctionString({
    ...toColor(theme.palette.themeSecondary)!,
    alpha: 23,
  });
  const cover: IStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    borderRadius: 2,

    '&:hover': {
      backgroundColor: coverHoverColor,
    },
    '&:hover > button': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    listing,
    selectedListing,
    contentContainer,
    imageContentContainer,
    badge,
    circularBadge,
    semiSquareBadge,
    iconBadge,
    imageBadge,
    title,
    invalidTitle,
    contentText,
    footnote,
    actionButton,
    cover,
  });
}
